import { render, staticRenderFns } from "./KidSearchApplication.vue?vue&type=template&id=13c4e786&"
import script from "./KidSearchApplication.vue?vue&type=script&lang=js&"
export * from "./KidSearchApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports